// src/admin/components/ClientFinancialSummary.jsx
//
// Compact financial KPI display for a single client
// (camp_count, total_billing, total_company_cost, total_profit, margin_percentage).

import React from 'react';
import { formatCurrency, formatPercentage } from './adminFormatters';
import { getProfitClass, getMarginClass } from './adminHelpers';

export default function ClientFinancialSummary({ client }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-[#6B7C7C]">Camps</p>
        <p className="mt-0.5 text-sm font-bold tabular-nums text-[#172B2B]">
          {client?.camp_count ?? 0}
        </p>
      </div>
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-[#6B7C7C]">Revenue</p>
        <p className="mt-0.5 text-sm font-bold tabular-nums text-[#172B2B]">
          {formatCurrency(client?.total_billing)}
        </p>
      </div>
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-[#6B7C7C]">Cost</p>
        <p className="mt-0.5 text-sm font-bold tabular-nums text-[#172B2B]">
          {formatCurrency(client?.total_company_cost)}
        </p>
      </div>
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-[#6B7C7C]">Profit</p>
        <p className={`mt-0.5 text-sm font-bold tabular-nums ${getProfitClass(client?.total_profit)}`}>
          {formatCurrency(client?.total_profit)}
        </p>
      </div>
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-[#6B7C7C]">Margin</p>
        <p className={`mt-0.5 text-sm font-bold tabular-nums ${getMarginClass(client?.margin_percentage)}`}>
          {formatPercentage(client?.margin_percentage)}
        </p>
      </div>
    </div>
  );
}
